import { SessionAction } from '../actions/session';
import * as constants from '../constants';
import { SessionState } from '../models';

export const sessionReducer = (state: SessionState = { sessionId: '' },
                               action: SessionAction): SessionState => {
  switch (action.type) {
    case constants.SESSION_STARTED:
      return {
        sessionId: action.sessionId,
      };
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/sessionReducer.ts